import RCTooltip from 'rc-tooltip'
import 'rc-tooltip/assets/bootstrap.css'
import { TooltipProps as RCTooltipProps } from 'rc-tooltip/lib/Tooltip'

export type TooltipProps = Pick<
  RCTooltipProps,
  | 'placement'
  | 'children'
  | 'overlay'
  | 'trigger'
  | 'overlayStyle'
  | 'overlayInnerStyle'
>

export const Tooltip = ({
  children,
  overlay,
  placement = 'bottom',
  trigger = ['hover'],
  overlayStyle,
  overlayInnerStyle
}: TooltipProps) => {
  return (
    <RCTooltip
      destroyTooltipOnHide
      // overlayClassName='tooltip'
      overlay={overlay}
      placement={placement}
      trigger={trigger}
      overlayStyle={overlayStyle}
      overlayInnerStyle={overlayInnerStyle}
    >
      {children}
    </RCTooltip>
  )
}
